import "babel-polyfill";
import "bootstrap";
import "./js/config";
import "./js/top-bar";
import "./js/pseo";
import "./js/notes-bar";
import { dom } from "@fortawesome/fontawesome-svg-core";

import "./scss/pseo.scss";
import "./template/header.css";
import "./template/footer.css";

// images not packed in bundle
import "./images/favicon.ico";
import "./images/experimental-data.png";
import "./template/census-logo-white.svg";

dom.watch();

